import { ProfileFill } from '@peacecover/icon';
import ReviewButton from './ReviewButton';
import type { ChatRoomType } from '../types/MarketCardType';
import { formatDateTime } from '@pocapan/shared/utils/DateUtil';

interface ChatItemProps {
  chat: ChatRoomType;
  tradingPhotoCardId: string;
  requestChatCount: number;
}

const ChatItem = ({ chat, tradingPhotoCardId, requestChatCount }: ChatItemProps) => {
  return (
    <div className="flex flex-row items-center px-[16px] py-[12px] justify-between">
      <div className="flex gap-[8px] items-center">
        {chat.traderProfilePictureUrl ? (
          <img
            src={chat.traderProfileThumbnailUrl || chat.traderProfilePictureUrl}
            alt="profile"
            className="w-[38px] h-[38px] rounded-full"
          />
        ) : (
          <div className="flex w-[38px] h-[38px] rounded-full bg-theirty-light dark:bg-theirty-dark items-center justify-center">
            <ProfileFill className="text-pure-white" size={27} />
          </div>
        )}
        <div className="flex flex-col gap-[3px]">
          <div className="flex flex-row items-center gap-[8px] leading-none">
            <p className="max-w-[85px] h-[17px] text-[14px] font-semibold text-text-main-lv2 truncate">
              {chat.traderNickname}
            </p>
            <p className="h-[13px] text-[11px] text-text-sub-lv1">
              {formatDateTime(chat.lastSentAt, 'a hh:mm')}
            </p>
          </div>
          <p className="text-[13px] text-text-main-lv3 w-[136px] leading-none truncate">
            {chat.lastMessage}
          </p>
        </div>
      </div>
      <ReviewButton
        tradingPhotoCardId={tradingPhotoCardId}
        chat={chat}
        requestChatCount={requestChatCount}
      />
    </div>
  );
};

export default ChatItem;
